import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import React, { Component } from 'react';
import { /* Header, Segment, Grid, Confirm, */Checkbox, Image, Button, Form, Message, Icon, Modal } from 'semantic-ui-react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import { AuthClient, getProfileAvatar, log } from '@emyw/core-lib';
// import ButtonLink from '../ButtonLink';
// import AvatarEditor from '../AvatarEditor';
import SocialLoginButton from '../SocialLoginButton';
const {
  REACT_APP_FACEBOOK_APP_ID,
  REACT_APP_GOOGLE_APP_ID /* , REACT_APP_AUTH_CLIENT_IMAGE_PATH */
} = process.env;
const socialLinkMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation ($profileId: Int!, $network: String!, $accessToken: String!, $jsonProfile: String!) {\n        socialLink(profileId: $profileId, network: $network, accessToken: $accessToken, jsonProfile: $jsonProfile) {\n            ok\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
const socialUnlinkMutation = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation ($profileId: Int!, $network: String!) {\n        socialUnlink(profileId: $profileId, network: $network) {\n            ok\n            avatarUrl\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
const useNetworkAvatarMutation = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    mutation ($profileId: Int!, $network: String!, $avatarUrl: String!) {\n        useNetworkAvatar(profileId: $profileId, network: $network, avatarUrl: $avatarUrl) {\n            ok\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
const getLinkedNetworksQuery = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    query ($profileId : Int!) {\n        getLinkedNetworks(profileId: $profileId) {\n            network\n            networkId\n            latestAccessToken\n            latestAvatarUrl\n        }\n    }\n"])));

/* const setAvatarMutation = gql`
    mutation ($profileId: Int!, $avatarBase64: String!) {
        setAvatar(profileId: $profileId, avatarBase64: $avatarBase64) {
            ok
            avatarUrl
            errors {
                path
                message
            }
        }
    }
`; */

/** Manage Social Account Linkage and Avatar
 * <br /><br /><hr /><br />
 * <div>
 * <h4>Manage Social Network and Avatar</h4>
 * Provides the features to link and unlink from supported social network sites.
 * Also, the user has may upload a specific profile picture or choose one from a linked social network.<br />
 * </div>
 */
class ManageSocialNetworkForm extends Component {
  constructor(props, context) {
    super(props, context);
    // ***********************************************
    // Avatar Region - Start
    // onChangeAvatarClick = () => { this.setState({ openAvatarEditor: true }); }
    // onAvatarEditorClose = () => { this.setState({ openAvatarEditor: false }); }
    this.onAvatarUpdated = avatarUrl => {
      this.setState({
        avatarUrl
      });
      if (this.props.onUpdate) this.props.onUpdate(avatarUrl);else log.warn('onUpdate prop required but not provided');
    };
    this.setNetworkAvatar = async (network, avatarUrl) => {
      const {
        id
      } = this.props.profile;
      try {
        const response = await this.props.useNetworkAvatarMutation({
          variables: {
            profileId: id,
            network,
            avatarUrl
          }
        });
        const {
          ok
        } = response.data.useNetworkAvatar;
        // log.trace(network, avatarUrl, response.data);
        if (ok) {
          this.onAvatarUpdated(avatarUrl);
          this.setState({
            errorMessage: undefined
          });
        }
        return ok;
      } catch (err) {
        log.trace('setNetworkAvatar');
        this.setState({
          errorMessage: err.message
        });
      }
      return false;
    };
    /* handleUpdateAvatar = async (newAvatarUrl) => {
        const response = await AuthClient.mutate({
            mutation: setAvatarMutation,
            variables: {
                profileId: this.props.profile.id,
                avatarBase64: newAvatarUrl,
            },
        });
        const { avatarUrl } = response.data.setAvatar;
        this.onAvatarUpdated(avatarUrl);
        // const avatarUrl = newAvatarUrl;
        // this.onAvatarUpdated(avatarUrl);
    } */
    this.loadLinkedSocialSiteState = async () => {
      const {
        id
      } = this.props.profile;
      const response = await AuthClient.query({
        query: getLinkedNetworksQuery,
        variables: {
          profileId: id
        },
        fetchPolicy: 'network-only'
      });
      // log.trace(response.data);
      response.data.getLinkedNetworks.map(linkedNetwork => {
        switch (linkedNetwork.network) {
          case 'google':
            this.setState({
              googleLinked: true,
              googleAvatarUrl: linkedNetwork.latestAvatarUrl
            });
            break;
          case 'facebook':
            this.setState({
              facebookLinked: true,
              facebookAvatarUrl: linkedNetwork.latestAvatarUrl
            });
            break;
          default:
        }
        return null;
      });
    };
    this.handleUseNetworkAvatar = network => {
      const message = 'Please confirm that you want to use your [NETWORK] profile picture?';
      switch (network) {
        case 'google':
          this.setState({
            confirmMessage: message.replace('[NETWORK]', 'Google'),
            showConfirmUseGooglePic: true
          });
          break;
        case 'facebook':
          this.setState({
            confirmMessage: message.replace('[NETWORK]', 'Facebook'),
            showConfirmUseFacebookPic: true
          });
          break;
        default:
      }
    };
    // Avatar Region - End
    // ***********************************************
    // ***********************************************
    // Social Network Region - Start
    this.linkSocialNetwork = async (network, profileId, user) => {
      try {
        const jsonProfile = JSON.stringify(user.profile);
        // log.trace(jsonProfile);
        const response = await this.props.socialLinkMutation({
          variables: {
            profileId,
            network,
            accessToken: user.token.accessToken,
            jsonProfile
          }
        });
        const {
          ok,
          errors
        } = response.data.socialLink;
        if (ok) {
          this.setState({
            errorMessage: undefined
          });
        } else {
          this.nodes[network].props.triggerLogout();
          this.setState({
            errorMessage: errors[0].message
          });
        }
        return ok;
      } catch (err) {
        this.setState({
          errorMessage: err.message
        });
      }
      return false;
    };
    this.unlinkSocialNetwork = async network => {
      const {
        id
      } = this.props.profile;
      try {
        const response = await AuthClient.mutate({
          mutation: socialUnlinkMutation,
          variables: {
            profileId: id,
            network
          }
        });
        const {
          ok,
          avatarUrl,
          errors
        } = response.data.socialUnlink;
        if (ok) {
          this.nodes[network].props.triggerLogout();
          if (avatarUrl !== this.state.avatarUrl) {
            // log.trace(`Profile picture unlinked. '${avatarUrl}' != '${this.state.avatarUrl}'`);
          }
          this.setState({
            errorMessage: undefined,
            avatarUrl
          });
        } else {
          // log.trace('unlinkSocialNetwork');
          this.setState({
            errorMessage: errors[0].message
          });
        }
        return ok;
      } catch (err) {
        // log.trace('unlinkSocialNetwork 2');
        this.setState({
          errorMessage: err.message
        });
      }
      return false;
    };
    this.handleLinkNetwork = async (network, user) => {
      const {
        id
      } = this.props.profile;
      switch (network) {
        case 'google':
        case !this.state.googleLinked:
          if (await this.linkSocialNetwork(network, id, user)) {
            this.setState({
              googleLinked: true,
              googleAvatarUrl: user.profile.profilePicURL
            });
          }
          break;
        case 'facebook':
        case !this.state.facebookLinked:
          if ((await this.linkSocialNetwork(network, id, user)) === true) {
            this.setState({
              facebookLinked: true,
              facebookAvatarUrl: user.profile.profilePicURL
            });
          }
          break;
        default:
          this.handleUnlinkNetwork(network);
      }
    };
    this.handleUnlinkNetwork = network => {
      // const { id } = this.props.user;
      const message = 'Are you sure you want to unlink [NETWORK] from your account?';
      switch (network) {
        case 'google':
        case this.state.googleLinked:
          this.setState({
            confirmMessage: message.replace('[NETWORK]', 'Google'),
            showGooglePlusUnlinkConfirm: true
          });
          break;
        case 'facebook':
        case this.state.facebookLinked:
          this.setState({
            confirmMessage: message.replace('[NETWORK]', 'Facebook'),
            showFacebookUnlinkConfirm: true
          });
          break;
        default:
      }
    };
    this.handleLinkFailure = err => {
      const error = String(err);
      log.trace('error:', error);
      this.setState({
        errorMessage: error.substring(0, error.indexOf('\n'))
      });
    };
    this.handleConfirmCancel = () => {
      this.setState({
        showFacebookUnlinkConfirm: false,
        showGooglePlusUnlinkConfirm: false,
        showConfirmUseGooglePic: false,
        showConfirmUseFacebookPic: false
      });
    };
    this.handleConfirmOk = async () => {
      if (this.state.showFacebookUnlinkConfirm) {
        this.setState({
          showFacebookUnlinkConfirm: false
        });
        if (await this.unlinkSocialNetwork('facebook')) {
          this.setState({
            facebookLinked: false,
            facebookAvatarUrl: null,
            showFacebookUnlinkConfirm: false
          });
        }
      } else if (this.state.showGooglePlusUnlinkConfirm) {
        this.setState({
          showGooglePlusUnlinkConfirm: false
        });
        if (await this.unlinkSocialNetwork('google')) {
          this.setState({
            googleLinked: false,
            googleAvatarUrl: null,
            showGooglePlusUnlinkConfirm: false
          });
        }
      } else if (this.state.showConfirmUseGooglePic) {
        this.setNetworkAvatar('google', this.state.googleAvatarUrl);
        this.setState({
          showConfirmUseGooglePic: false
        });
      } else if (this.state.showConfirmUseFacebookPic) {
        this.setNetworkAvatar('facebook', this.state.facebookAvatarUrl);
        this.setState({
          showConfirmUseFacebookPic: false
        });
      }
    };
    // This is needed for the react-social-login component for logout capability.
    // I wouldn't normally care about logging out, but the component checks if the user
    // is already connected to the social network and won't attempt to re-login in that case.
    // So without properly implementing logout if a user links, unlinks and links again,
    // if we didn't logout on the unlink, then the second link attempt will fail since we are
    // using the react-social-login component.
    this.instanceNodeRef = (provider, node) => {
      if (node) {
        this.nodes[provider] = node;
      }
    };
    this.state = {
      // openAvatarEditor: false,
      facebookLinked: false,
      googleLinked: false,
      facebookAvatarUrl: '',
      googleAvatarUrl: '',
      showGooglePlusUnlinkConfirm: false,
      showFacebookUnlinkConfirm: false,
      showConfirmUseGooglePic: false,
      showConfirmUseFacebookPic: false,
      confirmMessage: '',
      errorMessage: undefined,
      avatarUrl: this.props.profile.avatarUrl
    };
    this.nodes = {};
  }
  async componentDidMount() {
    await this.loadLinkedSocialSiteState();
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.avatarUrl !== nextProps.profile.avatarUrl) {
      this.onAvatarUpdated(nextProps.profile.avatarUrl);
    }
  }
  // Social Network Region - End
  // ***********************************************

  render() {
    const {
      profile
    } = this.props;
    const {
      // openAvatarEditor,
      facebookLinked,
      googleLinked,
      showGooglePlusUnlinkConfirm,
      showFacebookUnlinkConfirm,
      showConfirmUseGooglePic,
      showConfirmUseFacebookPic,
      confirmMessage,
      errorMessage,
      googleAvatarUrl,
      facebookAvatarUrl,
      avatarUrl
    } = this.state;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", {
      className: "fixedRow middle spaced socialNetwork_content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixedCol"
    }, getProfileAvatar({
      profile: {
        ...profile,
        avatarUrl
      },
      avatarFloat: 'left',
      iconSize: 'huge'
    })), /*#__PURE__*/React.createElement("div", {
      className: "fixedDivider socialNetworkDivider"
    }), /*#__PURE__*/React.createElement("div", {
      className: "fixedCol padded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixedRow middle padded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixedCol"
    }, /*#__PURE__*/React.createElement(SocialLoginButton, {
      className: "fixedRow middle",
      provider: "facebook",
      key: "facebook",
      disabled: facebookLinked,
      appId: REACT_APP_FACEBOOK_APP_ID,
      onLoginSuccess: response => this.handleLinkNetwork('facebook', response, socialLinkMutation),
      getInstance: this.instanceNodeRef.bind(this, 'facebook') // eslint-disable-line react/jsx-no-bind
      ,
      onLoginFailure: err => this.handleLinkFailure(err),
      onLogoutSuccess: res => res
    }, /*#__PURE__*/React.createElement(Button, {
      className: "square",
      color: "facebook",
      icon: "facebook",
      style: {
        marginRight: '20px'
      }
    }), /*#__PURE__*/React.createElement(Checkbox, {
      toggle: true,
      name: "facebookLinked",
      id: "facebookLinked",
      checked: facebookLinked,
      onClick: ( /* e */
      ) => {
        // e.preventDefault();
        if (facebookLinked) this.handleUnlinkNetwork('facebook');
      },
      onKeyPress: e => {
        if (e.charCode === 32) {
          e.target.checked = !e.target.checked;
        }
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "fixedCol socialNetworkingImage"
    }, /*#__PURE__*/React.createElement("span", null, facebookLinked ? 'Linked' : 'Not Linked'), /*#__PURE__*/React.createElement("div", null, facebookLinked && facebookAvatarUrl ? /*#__PURE__*/React.createElement(Image, {
      style: {
        cursor: 'pointer'
      },
      src: facebookAvatarUrl,
      avatar: true,
      onClick: () => this.handleUseNetworkAvatar('facebook')
    }) : /*#__PURE__*/React.createElement(Icon, {
      name: "user",
      className: "social_avatar",
      color: "blue",
      circular: true,
      inverted: true
    })))), /*#__PURE__*/React.createElement("div", {
      className: "fixedRow middle padded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixedCol"
    }, /*#__PURE__*/React.createElement(SocialLoginButton, {
      className: "fixedRow middle",
      provider: "google",
      key: "google",
      disabled: googleLinked,
      appId: REACT_APP_GOOGLE_APP_ID,
      onLoginSuccess: response => this.handleLinkNetwork('google', response, socialLinkMutation),
      getInstance: this.instanceNodeRef.bind(this, 'google') // eslint-disable-line
      ,
      onLoginFailure: err => this.handleLinkFailure(err),
      onLogoutSuccess: res => res
    }, /*#__PURE__*/React.createElement(Button, {
      className: "square",
      color: "google plus",
      icon: "google",
      style: {
        marginRight: '20px'
      }
    }), /*#__PURE__*/React.createElement(Checkbox, {
      toggle: true,
      name: "googleLinked",
      id: "googleLinked",
      checked: googleLinked,
      onClick: ( /* e */
      ) => {
        // e.preventDefault();
        // log.trace('google', googleLinked);
        if (googleLinked) this.handleUnlinkNetwork('google');
      },
      onKeyPress: e => {
        if (e.charCode === 32) {
          e.target.checked = !e.target.checked;
        }
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "fixedCol socialNetworkingImage"
    }, /*#__PURE__*/React.createElement("span", null, googleLinked ? 'Linked' : 'Not Linked'), /*#__PURE__*/React.createElement("div", null, googleLinked && googleAvatarUrl ? /*#__PURE__*/React.createElement(Image, {
      style: {
        cursor: 'pointer'
      },
      src: googleAvatarUrl,
      avatar: true,
      onClick: () => this.handleUseNetworkAvatar('google')
    }) : /*#__PURE__*/React.createElement(Icon, {
      name: "user",
      className: "social_avatar",
      color: "blue",
      circular: true,
      inverted: true
    }))))))), errorMessage ? /*#__PURE__*/React.createElement(Message, {
      size: "small",
      error: true,
      header: "Trouble with social network operation...",
      content: errorMessage
    }) : null, /*#__PURE__*/React.createElement(Modal, {
      open: showGooglePlusUnlinkConfirm || showFacebookUnlinkConfirm || showConfirmUseGooglePic || showConfirmUseFacebookPic,
      content: confirmMessage,
      closeOnDimmerClick: false,
      size: "tiny",
      actions: [/*#__PURE__*/React.createElement(Button, {
        content: "Cancel",
        type: "submit",
        key: "_cancel",
        onClick: this.handleConfirmCancel,
        compact: true,
        color: "grey"
      }), /*#__PURE__*/React.createElement(Button, {
        content: "OK",
        type: "submit",
        key: "_ok",
        onClick: this.handleConfirmOk,
        compact: true,
        primary: true
      })]
    }));
  }
}
export default compose(graphql(socialLinkMutation, {
  name: 'socialLinkMutation',
  client: AuthClient
}), graphql(useNetworkAvatarMutation, {
  name: 'useNetworkAvatarMutation',
  client: AuthClient
}))(ManageSocialNetworkForm);